import { ILinearDimension } from '../data/dimension/dimension';
import { EEntityType } from '../types';
import { LinearDimensionModel } from './2d/linearDimensionModel';
import BaseEntity from './BaseEntity';

export class LinearDimensionEntity extends BaseEntity<EEntityType.LinearDimension> {
  protected override _model2d: LinearDimensionModel;
  private _data: ILinearDimension;

  constructor(linearDimension: ILinearDimension) {
    super({
      type: EEntityType.LinearDimension,
      id: linearDimension.id
    });
    this._data = linearDimension;
    this._model2d = new LinearDimensionModel(linearDimension);
  }

  override update(linearDimension: ILinearDimension) {
    this._data = linearDimension;
    this._model2d.updateModel(linearDimension);
  }

  updateScale(scale: number) {
    this._model2d.updateScale(this._data, scale);
  }

  override set selected(selected: boolean) {
    if (this._selected === selected) return;

    this._selected = selected;
    this._model2d.setSelected(selected);
    this.update(this._data);
  }

  override get selected() {
    return this._selected;
  }

  setHover(hover: boolean) {
    this._model2d.hover = hover;
    this._model2d.updateModel(this._data);
  }

  updateTextView() {
    this._model2d.updateTextView();
  }

  updateTextVisible(visible: boolean) {
    this._model2d.updateTextVisible(visible);
  }

  override dispose() {
    this._model2d.dispose();
  }
}
